import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requireDist } from "../node_modules/postcss-nesting/node_modules/postcss-selector-parser/dist/index.js";
var distExports = requireDist();
const e = /* @__PURE__ */ getDefaultExportFromCjs(distExports);
export {
  e as default
};
//# sourceMappingURL=index3.js.map
